var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit, Renderer } from '@angular/core';
// import {DwActionAuthorizedService} from '@webdpt/framework';
import { ActivatedRoute } from '@angular/router';
import { FieldAuthorizedService } from './field-authorized.service';
var FieldAuthorizedDirective = /** @class */ (function () {
    function FieldAuthorizedDirective(elf, renderer, activatedRoute, fieldAuthorizedService) {
        this.elf = elf;
        this.renderer = renderer;
        this.activatedRoute = activatedRoute;
        this.fieldAuthorizedService = fieldAuthorizedService;
        this.hasView = false;
    }
    FieldAuthorizedDirective.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 设置默认状态
                        if (this.fxDefaultAuthorized) {
                            this.setAttribute(this.fxDefaultAuthorized);
                        }
                        return [4 /*yield*/, this.getCurrentStateId()];
                    case 1:
                        state = _a.sent();
                        if (state) {
                            this.actionAuthorizedInit(this.fxAuthorizedId, this.fxFieldId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FieldAuthorizedDirective.prototype.actionAuthorizedInit = function (authorizedId, actionId) {
        var _this = this;
        if (authorizedId && actionId) {
            // this.setAttribute('hidden');
            this.fieldAuthorizedService.setActionAuth(authorizedId, actionId);
            this.fieldAuthorizedService.fieldAuthorizedSubject$.subscribe(function (restriction) {
                _this.setAttribute(restriction);
            }, function (error) {
                console.log(actionId + ':' + error);
            });
        }
    };
    FieldAuthorizedDirective.prototype.getCurrentStateId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentSate, routeData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.fxAuthorizedId) {
                            return [2 /*return*/, this.fxAuthorizedId];
                        }
                        currentSate = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.activatedRoute.data.toPromise()];
                    case 2:
                        routeData = _a.sent();
                        if (routeData['dwRouteData'] && routeData['dwRouteData'].hasOwnProperty('dwAuthId')) {
                            currentSate = routeData['dwRouteData'].dwAuthId;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, currentSate];
                }
            });
        });
    };
    FieldAuthorizedDirective.prototype.setAttribute = function (restriction) {
        switch (restriction) { // 按鈕功能限制：allow 允許, hidden 隱藏, disabled 禁用
            case 'allow': // 允許
                this.seAttributeAllow();
                break;
            case 'hidden': // 隱藏
                this.seAttributeHidden(true);
                break;
            case 'disabled': // 禁用
                this.seAttributeDisabled(true);
                this.seAttributeHidden(false);
                break;
        }
    };
    // 允許
    FieldAuthorizedDirective.prototype.seAttributeAllow = function () {
        this.seAttributeHidden(false);
        this.seAttributeDisabled(false);
    };
    // 隱藏
    FieldAuthorizedDirective.prototype.seAttributeHidden = function (isHidden) {
        var display = '';
        if (isHidden) {
            display = 'none';
        }
        this.renderer.setElementStyle(this.elf.nativeElement, 'display', display);
    };
    // 禁用
    FieldAuthorizedDirective.prototype.seAttributeDisabled = function (isDisabled) {
        this.elf.nativeElement.disabled = isDisabled;
        this.renderer.setElementClass(this.elf.nativeElement, 'dw-f-action-disable', isDisabled);
    };
    return FieldAuthorizedDirective;
}());
export { FieldAuthorizedDirective };
